import { ArrowRightOutlined, SafetyCertificateOutlined } from '@ant-design/icons'
import { Button, Card, Col, Form, Input, notification, Row, Select } from 'antd'
import { createRef, useCallback, useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import * as api from 'src/configs/API'
import useWardsByProvinceId from 'src/hooks/useWardsByProvinceId'
import addressServices from 'src/services/address.service'
import contactServices from 'src/services/contact.service'
import { RULE_FORM } from 'src/utils/formValidation'
import request from 'src/utils/request'
import { rmVieTones, validateEmail } from 'src/utils/validation'
const recaptchaRef = createRef()
const Option = Select.Option

const FEATURES = [
	{
		src: '/images/contact-form/star.png',
		alt: '20k+',
		lines: ['20.000+ khách hàng', 'doanh nghiệp'],
	},
	{
		src: '/images/contact-form/delivery-done.png',
		alt: 'Giao nhanh',
		lines: ['Giao nhanh', 'toàn quốc'],
	},
	{
		src: '/images/contact-form/box.png',
		alt: 'Quản lý đơn',
		lines: ['Quản lý đơn hàng', 'thông minh'],
	},
]
const COL_STYLE = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	textAlign: 'center',
	gap: 8,
}

const ICON_STYLE = {
	width: 42,
	height: 42,
	objectFit: 'contain',
}

const ReciveInformationForm = ({ onNextStep }) => {
	const [loading, setLoading] = useState(false)
	const [isSubmit, setIsSubmit] = useState(false)
	const [address, setAddress] = useState("")
	const [wardId, setWardId] = useState(null)
	const [provinceId, setProvinceId] = useState(null)
	const [selectedFromCity, setSelectedFromCity] = useState(null)
	const [selectedFromWard, setSelectedFromWard] = useState(null)
	const { cities } = addressServices.usePMSCities()
	const fromWards = useWardsByProvinceId(selectedFromCity)
	const [token, setToken] = useState('')

	const [form] = Form.useForm()

	const analysisAddress = () => {
		request
			.pmsApi({
				url: api.PMS_APIs.API_CHECK_ADDRESS + '?address=' + encodeURIComponent(address),
				method: 'GET',
			})
			.then((response) => {
				console.log(response)
				if (response.isOk) {
					form.setFieldValue('province', response.provinceName);
					form.setFieldValue('ward', response.wardName);
					setProvinceId(response.provinceID);
					setWardId(response.wardID);
					// setIsCanCreate(true);
				} else {
					form.setFieldValue('province', "");
					form.setFieldValue('ward', "");
					setProvinceId("");
					setWardId("");
					// setIsCanCreate(false);
				}
			})
			.catch(console.log)
	}

	const handleFromCityChange = (value) => {

		setSelectedFromCity(value)
		setSelectedFromWard(null)
		form.setFieldsValue({
			provinceId: value,
			wardId: null
		})
	}
	const filterOption = useCallback((input, option) => {
		return rmVieTones(option.children).toLowerCase().includes(rmVieTones(input).toLowerCase())
	}, [])

	const handleSubmit = async (values) => {
		if (!token || token === '') {
			notification.error({
				message: 'Vui lòng xác thực ReCAPTCHA!',
			})
			return;
		}
		setLoading(true)
		try {
			values.buttonId = 'register_contact'
			values.formId = 'register_contact_form'
			// console.log(values)
			const response = contactServices.insertContactPushtoCRMLead(values, { 'TokenRecaptcha': token })
			if (!response.isError) {
				setIsSubmit(true)
				form.resetFields()
			}
		} catch (error) {
			console.log(error)
		}
		setLoading(false)
	}
	return (
		<div>
			{!isSubmit ? (
				<>
					<Card className="reciveInformation__card">
						<Form
							className="reciveInformation__form"
							form={form}
							name="home-contact-form"
							layout="vertical"
							onFinish={handleSubmit}
						>
							<Row gutter={10} wrap>
								<Col span={24} className="form-row">
									<span style={{ fontSize: 18, fontWeight: 600, color: '#CC0000' }}>
										<img src="/images/contact-form/hands.png" style={{ width: 21 }}></img> Đăng ký
										tư vấn - điền ngay!
									</span>
								</Col>
								<Col span={24} className="form-row">
									<Row gutter={12}>
										<Col xl={24} lg={24} md={24} sm={24} xs={24} className="form-row">
											<Form.Item
												rules={[
													{ required: true, message: 'Vui lòng nhập tên' },
													{ whitespace: true, message: 'Vui lòng nhập tên' },
													{ max: 200, message: 'Vui lòng nhập tối đa 200 ký tự' },
												]}
												style={{ marginTop: 12 }}
												name="name"
											>
												<div className="ph-wrap"><Input
													className="placeholder-black"
													placeholder=" "
													prefix={
														<img src="/images/contact-form/userprefix.png" style={{ width: 21 }} />
													}
												/>
													<span className="ph-fake">
														{form.getFieldValue('name') && form.getFieldValue('name') !== '' ? form.getFieldValue('name') : 'Họ và tên người liên hệ'}
														{!form.getFieldValue('name') || form.getFieldValue('name') === '' ? <span className="req">*</span> : null}
													</span></div>
											</Form.Item>
										</Col>
										<Col xl={24} lg={24} md={24} sm={24} xs={24}>
											<Form.Item
												rules={RULE_FORM.PHONE_NUMBER}
												style={{ marginTop: 12 }}
												name="phone"
											>
												<div className="ph-wrap">	<Input
													className="placeholder-black"
													prefix={
														<img
															src="/images/contact-form/phoneprefix.png"
															style={{ width: 21 }}
														></img>
													}
													placeholder=" "
												/>
													<span className="ph-fake">
														{form.getFieldValue('phone') && form.getFieldValue('phone') !== '' ? form.getFieldValue('phone') : 'Số điện thoại'}
														{!form.getFieldValue('phone') || form.getFieldValue('phone') === '' ? <span className="req">*</span> : null}
													</span></div>
											</Form.Item>
										</Col>
									</Row>
								</Col>
								<Col span={24} className="form-row">
									<Form.Item
										rules={[
											() => ({
												validator(_, value) {
													if (!value) {
														return Promise.resolve()
													} else if (value && validateEmail(value)) {
														return Promise.resolve()
													}

													return Promise.reject(new Error('Email không đúng định dạng!'))
												},
											}),
										]}
										style={{ marginTop: 12 }}
										name="email"
									>
										<Input
											className="placeholder-black"
											prefix={
												<img src="/images/contact-form/mailprefix.png" style={{ width: 21 }}></img>
											}
											placeholder="Email"
										/>
									</Form.Item>
								</Col>
								<Col span={24} className="form-row">
									<Form.Item
										style={{ marginTop: 12 }}
										name="provinceId"
										rules={[
											{
												required: true,
												message: 'Vui lòng chọn tỉnh/thành phố',
											},
										]}
									>
										<div className="ph-wrap">
											<Select
												className="placeholder-black select"
												placeholder=" "
												suffixIcon={<img src="/images/contact-form/teleprefix.png" style={{ width: 21 }}></img>}
												onChange={handleFromCityChange}
												showSearch
												filterOption={filterOption}
											>
												{cities.map((c) => (
													<Option key={c.provinceID} value={c.provinceID}>
														{c.provinceName}
													</Option>
												))}
											</Select>
											<span className="ph-fake">
												{(!form.getFieldValue('provinceId') || form.getFieldValue('provinceId') === '') && (
													<>
														Tỉnh/Thành Phố <span className="req">*</span>
													</>
												)}
											</span>
										</div>

									</Form.Item>
								</Col>
								<Col span={24} className="form-row" style={{ marginTop: 'auto' }}>
									<Form.Item
										label={''}
										style={{ marginTop: 12 }}
										name="wardId"
										rules={[
											{
												required: true,
												message: 'Vui lòng chọn phường xã',
											},
										]}
									>
										<div className="ph-wrap">
											<Select
												className="placeholder-black"
												showSearch
												filterOption={filterOption}
												placeholder=" "
												suffixIcon={<img src="/images/contact-form/teleprefix.png" style={{ width: 21 }}></img>}
												defaultValue={selectedFromWard}
												onChange={(value) => {
													setSelectedFromWard(value)
													form.setFieldsValue({ wardId: value })
												}}
											>
												{fromWards?.length &&
													fromWards.map((d) => (
														<Option key={d.wardID} value={d.wardID}>
															{d.wardName}
														</Option>
													))}
											</Select>
											<span className="ph-fake">
												{(!form.getFieldValue('wardId') || form.getFieldValue('wardId') === '') && (
													<>
														Phường/xã <span className="req">*</span>
													</>
												)}
											</span>
										</div>
									</Form.Item>
								</Col>
								{/* <Col span={24} className="form-row">
									<Form.Item
										rules={[
											{ min: 10, message: 'Địa chỉ phải lớn hơn 10 ký tự!' },
											{ required: true, message: 'Vui lòng nhập địa chỉ' },
											{ max: 500, message: 'Vui lòng nhập tối đa 500 ký tự' },
										]}
										style={{ marginTop: 12 }}
										name="content"
									>
										<div className="ph-wrap"><Input
											className="placeholder-black"
											prefix={
												<img src="/images/contact-form/teleprefix.png" style={{ width: 21 }}></img>
											}
											placeholder=" "
											onChange={(e) => {
												setAddress(e.target.value);
											}}
										// onBlur={analysisAddress}
										// onKeyDown={(e) => {
										// 	if (e.code === 'Enter') {
										// 		analysisAddress()
										// 	}
										// }}

										/>
											<span className="ph-fake">
												{form.getFieldValue('content') && form.getFieldValue('content') !== '' ? form.getFieldValue('content') : 'Địa chỉ công ty chi tiết '}
												{!form.getFieldValue('content') || form.getFieldValue('content') === '' ? <span className="req">*</span> : null}
											</span>
										</div>
									</Form.Item>
								</Col> */}
								<Col span={24}>
									<Form.Item
										name="Captcha"
										style={{
											marginTop: 18,
										}}
									>
										<ReCAPTCHA
											sitekey={api.SITE_KEY}
											onChange={(token) => setToken(token)}
											onExpired={(token) => setToken('')}
											ref={recaptchaRef}
											hl={'vi'}
										/>
									</Form.Item>
								</Col>
								<Col span={24} className="form-row">
									<p className="form-note">
										<SafetyCertificateOutlined />
										&nbsp; Bằng việc gửi thông tin, bạn đồng ý với
										<a href="https://247express.vn/chinh-sach-bao-mat"> chính sách bảo mật </a>của
										chúng tôi.{' '}
									</p>
								</Col>
								<Col span={24} className="form-row">
									<div className="send-btn__wrapper">
										<Button
											style={{ width: '100%', height: 44, fontSize: 16, lineHeight: '24px' }}
											type="primary"
											htmlType="submit"
										>
											Nhận Tư Vấn Ngay <ArrowRightOutlined />
										</Button>
									</div>
								</Col>
								<Col span={24} className="form-row" style={{ textAlign: 'center', marginTop: 12 }}>
									<i>
										Bạn không phải là Khách hàng Doanh nghiệp? Tìm hiểu thêm{' '}
										<a href="https://247express.vn/tin-tuc/tin-tuc-va-su-kien/huong-dan-gui-hang-danh-cho-khach-hang-le/759?utm_source=LDPd">
											<span style={{ textDecoration: 'underline' }}>tại đây.</span>
										</a>
									</i>
								</Col>
							</Row>
						</Form>
					</Card>
					<Row align="middle" justify="space-between" style={{ marginTop: 24, padding: '0 20px' }}>
						{FEATURES.map((f) => (
							<Col key={f.alt} xs={8} md={6} style={COL_STYLE}>
								<img src={f.src} alt={f.alt} style={ICON_STYLE} />
								<span className="feature-text">
									{f.lines[0]}
									<br />
									{f.lines[1]}
								</span>
							</Col>
						))}
					</Row>
				</>
			) : (
				<div style={{ padding: '80px 24px' }}>
					<img
						src="/images/contactform_img.png"
						alt="Liên hệ thành công"
						style={{ width: 300, display: 'block', margin: '0 auto' }}
					/>
					<h1 style={{ textAlign: 'center', fontSize: 40, fontWeight: 'bold', lineHeight: '48px' }}>
						Cảm ơn bạn đã tin tưởng và liên hệ với 247Express!
					</h1>
					<p style={{ color: '#5E6278', textAlign: 'center' }}>
						Thông tin của bạn đã được chuyển đến bộ phận tiếp nhận. Đội ngũ của chúng tôi sẽ liên hệ
						để tư vấn giải pháp phù hợp nhất theo nhu cầu vận chuyển của bạn trong vòng 4 giờ làm
						việc (trừ chủ nhật & ngày lễ).
					</p>
				</div>
			)}
		</div>
	)
}

export default ReciveInformationForm
